@if (vm$ | async; as vm) {
    @if (!vm.konfigurationOk) {
        <empty-page-badge overskrift="Konfigurationsfejl"> Prisberegneren mangler at blive konfigureret </empty-page-badge>
    }
    @if (vm.konfigurationOk) {
        <form [formGroup]="vm.formGroup">
            <div class="panel-beregner-og-resultat">
                <div class="panel-beregner">
                    @if (
                        vm.konfiguration.fjernvarme.bbrPrisPrM2 ||
                        vm.konfiguration.fjernvarme.bbrPriserPrM2?.length ||
                        vm.konfiguration.fjernvarme.groenOmstillingsbidragPrM2
                    ) {
                        <mat-form-field>
                            <mat-label>Hvor stort er dit hus (BBR-boligareal)?</mat-label>
                            <input matInput type="number" id="Boligareal" formControlName="boligareal" (focus)="onFocus($event)" />
                            <span matSuffix>m<sup>2</sup></span>
                            <mat-hint></mat-hint>
                        </mat-form-field>
                    }
                    <mat-form-field>
                        <mat-label>Hvordan opvarmer du dit hus?</mat-label>
                        <mat-select #NuvaerendeVarmekilde formControlName="varmekilde">
                            @for (varmekilde of vm.varmekilder; track varmekilde) {
                                <mat-option [value]="varmekilde.id">
                                    {{ varmekilde.navn }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @switch (vm.formGroup.get("varmekilde").value) {
                        <!-- El -->
                        @case (1) {
                            <mat-form-field>
                                <mat-label>Hvor meget el bruger du til opvarmning om året?</mat-label>
                                <input matInput type="number" formControlName="forbrugEl" (focus)="onFocus($event)" />
                                <span matSuffix>kWh</span>
                                <mat-hint></mat-hint>
                            </mat-form-field>
                        }
                        <!-- Olie -->
                        @case (3) {
                            <mat-form-field>
                                <mat-label>Hvor meget olie bruger du om året?</mat-label>
                                <input matInput type="number" formControlName="forbrugOlie" (focus)="onFocus($event)" />
                                <span matSuffix>liter</span>
                                <mat-hint></mat-hint>
                            </mat-form-field>
                            @if (vm.konfiguration.olie.virkningsgrad.vaelgKedlensAlder) {
                                <mat-form-field>
                                    <mat-label>Hvor gammelt er dit oliefyr?</mat-label>
                                    <mat-select formControlName="olieFyrAlder">
                                        @if (!!vm.konfiguration.olie.virkningsgrad.virkningsgrad0til4Aar) {
                                            <mat-option [value]="1"> 0-4 år</mat-option>
                                        }
                                        @if (!!vm.konfiguration.olie.virkningsgrad.virkningsgrad5til8Aar) {
                                            <mat-option [value]="2"> 5-8 år</mat-option>
                                        }
                                        @if (!!vm.konfiguration.olie.virkningsgrad.virkningsgrad9tilNAar) {
                                            <mat-option [value]="3"> Ældre end 8 år</mat-option>
                                        }
                                    </mat-select>
                                    <mat-hint></mat-hint>
                                </mat-form-field>
                            }
                        }
                        <!-- Naturgas -->
                        @case (2) {
                            <mat-form-field>
                                <mat-label>Hvor meget naturgas bruger du om året?</mat-label>
                                <input matInput type="number" formControlName="forbrugNaturgas" (focus)="onFocus($event)" />
                                <span matSuffix>m<sup>3</sup></span>
                                <mat-hint></mat-hint>
                            </mat-form-field>
                            @if (vm.konfiguration.naturgas.virkningsgrad.vaelgKedlensAlder) {
                                <mat-form-field>
                                    <mat-label>Hvor gammelt er dit naturgasfyr?</mat-label>
                                    <mat-select formControlName="naturgasKeddelAlder">
                                        @if (!!vm.konfiguration.naturgas.virkningsgrad.virkningsgrad0til4Aar) {
                                            <mat-option [value]="1"> 0-4 år</mat-option>
                                        }
                                        @if (!!vm.konfiguration.naturgas.virkningsgrad.virkningsgrad5til8Aar) {
                                            <mat-option [value]="2"> 5-8 år</mat-option>
                                        }
                                        @if (!!vm.konfiguration.naturgas.virkningsgrad.virkningsgrad9tilNAar) {
                                            <mat-option [value]="3"> Ældre end 8 år</mat-option>
                                        }
                                    </mat-select>
                                    <mat-hint></mat-hint>
                                </mat-form-field>
                            }
                        }
                        <!-- Træpiller -->
                        @case (4) {
                            <mat-form-field>
                                <mat-label>Hvor mange træpiller bruger du om året?</mat-label>
                                <input matInput type="number" formControlName="forbrugTraepiller" (focus)="onFocus($event)" />
                                <span matSuffix>kg</span>
                                <mat-hint></mat-hint>
                            </mat-form-field>
                            @if (vm.konfiguration.traepiller.virkningsgrad.vaelgKedlensAlder) {
                                <mat-form-field>
                                    <mat-label>Hvor gammelt er dit pillefyr?</mat-label>
                                    <mat-select formControlName="pillefyrAlder">
                                        @if (!!vm.konfiguration.traepiller.virkningsgrad.virkningsgrad0til4Aar) {
                                            <mat-option [value]="1"> 0-4 år</mat-option>
                                        }
                                        @if (!!vm.konfiguration.traepiller.virkningsgrad.virkningsgrad5til8Aar) {
                                            <mat-option [value]="2"> 5-8 år</mat-option>
                                        }
                                        @if (!!vm.konfiguration.traepiller.virkningsgrad.virkningsgrad9tilNAar) {
                                            <mat-option [value]="3"> Ældre end 8 år</mat-option>
                                        }
                                    </mat-select>
                                    <mat-hint></mat-hint>
                                </mat-form-field>
                            }
                        }
                        <!-- Varmepumpe -->
                        @case (5) {
                            <mat-form-field>
                                <mat-label>Hvor meget el bruger din varmepumpe om året?</mat-label>
                                <input matInput type="number" formControlName="forbrugVarmepumpe" (focus)="onFocus($event)" />
                                <span matSuffix>kWh</span>
                                <mat-hint></mat-hint>
                            </mat-form-field>
                        }
                    }
                    @if (
                        !!vm.konfiguration.fjernvarme.varmemesterordningPrAar &&
                        (!!vm.konfiguration.fjernvarme.nyUnitPris || !!vm.konfiguration.fjernvarme.investeringsomkostninger)
                    ) {
                        <mat-slide-toggle formControlName="oenskerVarmemesterOrdning">
                            {{ vm.konfiguration.tekster.medVarmemesterordning }}
                        </mat-slide-toggle>
                    }
                    @if (vm.konfiguration.fjernvarme.bbrTrappemodel && vm.konfiguration.fjernvarme.bbrPriserPrM2[0].konverteringsbidragPrM2) {
                        <mat-card-content>
                            <h4 class="konverteringbidragHeader">{{ vm.konfiguration.tekster.konverteringsbidragOverskrift }}</h4>
                            <p>{{ vm.konfiguration.tekster.konverteringsbidragSubtekst1 }}</p>
                            <p>{{ vm.konfiguration.tekster.konverteringsbidragSubtekst2 }}</p>
                        </mat-card-content>
                        <mat-slide-toggle
                            formControlName="oenskerFordelingAfKonverteringsbidrag"
                            [checked]="vm.state.oenskerFordelingAfKonverteringsbidrag"
                            (change)="toggle($event)"
                        >
                            {{
                                vm.state.oenskerFordelingAfKonverteringsbidrag
                                    ? vm.konfiguration.tekster.konverteringsbidragToggle2
                                    : vm.konfiguration.tekster.konverteringsbidragToggle1
                            }}
                            {{ findKonverterinsbidrag(vm.resultat.fjernvarme.detaljer, vm.konfiguration.tekster.konverteringsbidragOverskrift) | number: "0.0-0" }}
                            kr.
                            {{ vm.state.oenskerFordelingAfKonverteringsbidrag ? "pr. år" : " " }}
                        </mat-slide-toggle>
                    }
                    @if (vm.state.oenskerFordelingAfKonverteringsbidrag) {
                        <mat-form-field style="margin-top: 10px">
                            <mat-label>Vælg antal år til fordeling</mat-label>
                            <mat-select #nuvaerendeAntalAar formControlName="konverteringbidragAntalAar">
                                @for (antalAar of vm.konfiguration.fjernvarme.konverteringsbidragAntalAar; track antalAar) {
                                    <mat-option [value]="antalAar"> betal over {{ antalAar }} år </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                    <!--mat-form-field *ngIf="vm.state.oenskerFordelingAfKonverteringsbidrag">
          <mat-label>Fordeling af konverteringsbidrag</mat-label>
          <input matInput type="number" formControlName="konverteringbidragAntalAar"
            (focus)="onFocus($event)" />
            <span matSuffix>år</span>
            <mat-hint>Hvor mange år ønsker du at fordele dit konverteringsbidrag over</mat-hint>
          </mat-form-field-->
                </div>
                <!-- Resultat -->
                <mat-card-content>
                    <div class="panel-resultat">
                        <h3>Resultat</h3>
                        <table [class.table-kun1]="vm.konfiguration.visKunUdgiftResultat">
                            <tr>
                                <td>Vejledende årlige udgifter ved fjernvarme:</td>
                                <td>
                                    <div class="resultat">{{ vm.resultat.fjernvarme.ialt.beloeb | number: "1.0-0" }} kr.</div>
                                    <small>inkl. moms pr. år</small>
                                </td>
                            </tr>
                            @if (vm.resultat.besparelseKr && !vm.konfiguration.visKunUdgiftResultat) {
                                <tr>
                                    <td>Årlig {{ vm.resultat.besparelseEllerAendringTekst }} ved skift til fjernvarme:</td>

                                    <td>
                                        <div class="resultat">{{ vm.resultat.besparelseKr | number: "1.0-0" }} kr.</div>
                                        <small>inkl. moms pr. år</small>
                                    </td>
                                </tr>
                            }
                            @if (vm.resultat.besparelseKr && !vm.konfiguration.visKunUdgiftResultat) {
                                <tr>
                                    <td>Årlig {{ vm.resultat.besparelseEllerAendringTekst }} svarer til:</td>
                                    <td>
                                        <div class="resultat">{{ vm.resultat.besparelsePct | number: "1.0-0" }}%</div>
                                        <small>&nbsp;</small>
                                    </td>
                                </tr>
                            }
                        </table>
                    </div>
                </mat-card-content>
            </div>
            <hr />
            <!-- Beregningsgrundlag -->
            @if (vm.konfiguration.visDetaljeretResultat) {
                <div class="panel-beregningsgrundlag">
                    <h3>Beregningsgrundlag</h3>
                    <div>Hvad koster det dig at varme dit hus op?</div>
                    <div>
                        <div>Dit varmeforbrug pr. år</div>
                        <div>
                            <strong>{{ vm.resultat.mwh | number: "1.2-2" }} MWh</strong>&nbsp;
                            <small>{{ vm.resultat.mwhForklaring }}</small>
                        </div>
                    </div>
                    @if (!!vm.resultat.sammenligningskilde.ialt.beloeb) {
                        <div>
                            <div>
                                Vejledende årlige varmeregning med <strong>{{ vm.varmekildeTekst | lowercase }}</strong>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div>
                                    <strong>{{ vm.resultat.sammenligningskilde.ialt.beloeb | number: "1.0-0" }} kr.</strong>&nbsp;
                                    <small [innerHTML]="vm.resultat.sammenligningskilde.ialt.tekst2"></small>
                                </div>
                                <small>
                                    <a (click)="vm.state.visDetaljerSammenligningskilde = !vm.state.visDetaljerSammenligningskilde">
                                        {{ getDetaljerText(vm.state.visDetaljerSammenligningskilde) }}</a
                                    >
                                </small>
                            </div>
                            @if (vm.state.visDetaljerSammenligningskilde) {
                                <prisberegner-specifikation [linjer]="vm.resultat.sammenligningskilde.detaljer"> </prisberegner-specifikation>
                            }
                        </div>
                    }
                    <div>
                        <div>Vejledende årlige varmeregning med <strong>fjernvarme</strong></div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div>
                                <strong>{{ vm.resultat.fjernvarme.ialt.beloeb | number: "1.0-0" }} kr.</strong>&nbsp;
                                <small [innerHTML]="vm.resultat.fjernvarme.ialt.tekst2"></small>
                            </div>
                            <small>
                                <a (click)="vm.state.visDetaljerFjernvarme = !vm.state.visDetaljerFjernvarme"> {{ getDetaljerText(vm.state.visDetaljerFjernvarme) }}</a>
                            </small>
                        </div>
                        @if (vm.state.visDetaljerFjernvarme) {
                            <prisberegner-specifikation [linjer]="vm.resultat.fjernvarme.detaljer"> </prisberegner-specifikation>
                        }
                    </div>
                    @if (!!vm.resultat.sammenligningskilde.ialt.beloeb) {
                        <div>
                            <div>Årlig {{ vm.resultat.besparelseEllerAendringTekst }} ift. {{ vm.varmekildeTekst | lowercase }}</div>
                            <div>
                                <strong>{{ vm.resultat.besparelseKr | number: "1.0-0" }} kr.</strong>&nbsp;
                                <small>
                                    svarende til en {{ vm.resultat.besparelseEllerAendringTekst }} på
                                    <strong>{{ vm.resultat.besparelsePct | number: "1.0-0" }}%</strong>
                                </small>
                            </div>
                        </div>
                    }
                </div>
            }
            @if (false) {
                <div>
                    <pre>
                {{ vm.konfiguration | json }}
              </pre
                    >
                    <pre>
                {{ vm.model | json }}
              </pre
                    >
                    <pre>
                {{ vm.resultat | json }}
              </pre
                    >
                </div>
            }
        </form>
    }
}
